import React from 'react'
import 'rc-slider/assets/index.css'
import 'react-input-range/lib/css/index.css'
import PropTypes from 'prop-types'
import CustomDrawer from 'common/CustomDrawer'
import { COMMENT_DRAWER_MODES } from './CommentDrawer.constant'
import CommentBox from './CommentBox'
import './CommentDrawer.less'

const DEFAULT_TITLE = 'Comentarios'

const CommentDrawer = ({
  mode,
  title,
  maxLength,
  onBack,
  onSave,
  onCancel,
  comment,
  open,
  children,
  customStyles,
}) => {
  const handleOnBack = () => {
    onBack()
  }

  return (
    <CustomDrawer open={open} title={title} onClose={handleOnBack} customStyles={customStyles} >
      <div className="comment-drawer">
        <CommentBox
          mode={mode}
          maxLength={maxLength}
          onBack={onBack}
          onSave={onSave}
          onCancel={onCancel}
          comment={comment}
        />
        {children}
      </div>
    </CustomDrawer>
  )
}

CommentDrawer.propTypes = {
  open: PropTypes.bool,
  mode: PropTypes.string,
  maxLength: PropTypes.number,
  onBack: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  comment: PropTypes.string,
  title: PropTypes.node
}

CommentDrawer.defaultProps = {
  mode: COMMENT_DRAWER_MODES.EDIT,
  title: DEFAULT_TITLE,
  maxLength: 250,
  onBack: () => {},
  onSave: () => {},
  onCancel: () => {},
  comment: '',
  open: false
}

export default CommentDrawer
